import React from "react";
import "./AppLoading.scss";
import { Constants } from "@constants/Constants";
const AppLoading = () => {
  const loaderEl = document?.getElementById("apollo-html-loader");
  if (loaderEl) {
    document?.body?.removeChild(loaderEl);
  }
  return (
    <div className="apollo-loading">
      <div className="apollo-loading__container">
        <img
          className="apollo-loading__logo"
          src={`${Constants.API.API_PATH}${Constants.IMAGE.PATH}${Constants.IMAGE.GARTNER_LOGO}`}
          alt={Constants.COMMON.LOGO_ALTERNATE_TEXT}
        />
        {/* We use a custom LinearProgress here instead of genie-ui/react
            to match the CSS of loader in index.html */}
        <div className="apollo-loading__progressBar_container">
          <div className="apollo-loading__progressBar" />
        </div>
      </div>
    </div>
  );
};

export default AppLoading;
